/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  data() {
    return {
      waitForRegistrationResponse: true,
      showLoadingModal: false,
      asyncTypes: {
        AUTO: 'auto',
        REG: 'register',
      },
    };
  },
  methods: {
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
    ...mapActions('profile', [
      'callForAuthorization',
      'getUserLoginDetails',
      'storeLoginInfo',
    ]),
    ...mapMutations('profile', [
      'setRegistrationInfo',
      'setFirstTimeEntry',
    ]),
    getNextRegistrationStepForRequestPin() {
      switch (this.simpleRegistration) {
      case this.availableFlows.SIMPLE_BOTH_WEB_REGISTRATION_AND_LOGIN.propertyName: return () => {
        this.$axios.get(`api/alternateRequestPin?msisdn=${this.user.msisdn}&lang=${this.getLocale}&operator=${this.operatorPicked}`).then((response) => {
          const resp = response.data.responseEnum;
          if (resp === 'OPERATION_SUCCESS') {
            this.setRegistrationInfo(response.data.data);
            this.$router.push('register2');
            this.user.msisdn = '';
            this.waitForResponse = false;
          } else if (resp === 'MSISDN_NOT_EXIST') {
            this.setRegistrationInfo(response.data.data);
            this.$router.push('register2subscribe');
          } else {
            this.mapErrorMessages(resp);
            this.hasErrors = true;
            this.waitForResponse = false;
          }
        }).catch((error1) => {
          console.log(`Invoking api/requestPin failed with the following error: ${error1}`);
        });
      };
      default: return () => {
        this.$axios.get(`api/requestPin?msisdn=${this.user.msisdn}&lang=${this.getLocale}&operator=${this.operatorPicked}`).then((response) => {
          const resp = response.data.responseEnum;
          if (resp === 'OPERATION_SUCCESS') {
            this.user.msisdn = '';
            this.setRegistrationInfo(response.data.data);
            this.storeOperator(this.operatorPicked);
            if (this.operatorPicked) {
              this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${this.operatorPicked}`).then((res) => {
                this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
                this.setDisplayPrice({ value: res.data.data.displayPrice });
                this.$router.push('register2');
                this.waitForResponse = false;
              });
            } else {
              this.$router.push('register2');
              this.waitForResponse = false;
            }
          } else {
            // eslint-disable-next-line
            if (this.operatorPicked) {
              this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${this.operatorPicked}`).then((res) => {
                this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
                this.mapErrorMessages(resp);
                this.hasErrors = true;
              });
            } else {
              this.mapErrorMessages(resp);
              this.hasErrors = true;
            }
            this.waitForResponse = false;
          }
        });
      };
      }
    },
    getNextRegistrationStep(forceDefault, hasServerTrack) {
      if (forceDefault) {
        return (asyncPinVerification) => { this.defaultVerifyAction(asyncPinVerification, hasServerTrack); };
      }
      switch (this.simpleRegistration) {
      case this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName: return () => {
        const userData = {
          username: this.registrationInfoMsisdn,
          password: this.user.pin,
          rememberMe: true,
          correlationId: this.getCorrelationId,
          clickId: this.getClickId,
          refUrl: this.getRefUrl,
          campaignId: this.getCampaignId,
          publisherId: this.getPublisherId,
          freePlayPoints: encodeURIComponent(this.registrationPoints.totalPoints || ''),
          prize: encodeURIComponent(this.registrationPoints.freeGamePrize || ''),
          inviteReferral: this.getInviteReferral,
          fbReferral: this.fbReferral,
        };
        this.callForAuthorization(userData).then((responseForCall) => {
          if (this.getUserAuthorized) {
            this.sendCompleteRegistrationEvent();
            this.getUserLoginDetails().then(() => {
              this.setFirstTimeEntry(true);
              this.updateUserLanguage();
              this.$router.push('home');
              this.waitForResponse = false;
              this.waitForRegistrationResponse = false;
            });
          } else {
            if (responseForCall) {
              if (responseForCall === 'PIN_EXPIRED') {
                this.message = 'visitor_sign_up_2_pin_expired';
              } else if (responseForCall === 'WRONG_PIN') {
                this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
              } else if (responseForCall === 'MSISDN_INVALID') {
                this.message = 'visitor_sign_up_invalid_msisdn_msg';
              } else {
                this.message = 'home_profile_profile_edit_server_unvailable';
              }
            }
            this.hasErrors = true;
            this.waitForResponse = false;
            this.waitForRegistrationResponse = false;
          }
        });
      };
      case this.availableFlows.SIMPLE_WITHOUT_WEB_REGISTRATION.propertyName: return () => {
        // eslint-disable-next-line
        console.log('SIMPLIFY_REGISTRATION_WITHOUT_WEB_REG case');
      };
      case this.availableFlows.SIMPLE_BOTH_WEB_REGISTRATION_AND_LOGIN.propertyName: return (isWifiFlow) => {
        if (isWifiFlow) {
          this.$axios.get(`api/getRegisterUrl?msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}&cid=${this.getCorrelationId}`).then((response) => {
            const redirectionUrl = response.data.data;
            if (!redirectionUrl) { // already sub case
              this.$axios.get(`api/getStatus?status=0&msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}&lang=${this.getLocale}`).then((res) => {
                if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                  if (res.data.data[0] === 'ALREADY_REGISTERED') {
                    this.storeLoginInfo({
                      token: res.data.data[1],
                      rememberMeParameter: false,
                      username: res.data.data[2],
                    });
                    this.getUserLoginDetails().then(() => {
                      this.updateUserLanguage();
                      this.$router.push('home');
                    });
                  } else { // error case
                    this.$router.push('/');
                  }
                }
                this.waitForResponse = false;
              });
            } else {
              window.location.href = redirectionUrl; // redirect to partner
            }
          });
        } else {
          this.$axios.get(`api/verifyPin?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}&publisherId=${this.getPublisherId}`).then((response) => {
            const resp = response.data.responseEnum;
            if (resp === 'OPERATION_SUCCESS') {
              this.$axios.get(`api/getRegisterUrl?msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}&cid=${this.getCorrelationId}`).then((response) => {
                const redirectionUrl = response.data.data;
                if (!redirectionUrl) { // already sub case
                  this.$axios.get(`api/getStatus?status=0&msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}&lang=${this.getLocale}`).then((res) => {
                    if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                      if (res.data.data[0] === 'ALREADY_REGISTERED') {
                        this.storeLoginInfo({
                          token: res.data.data[1],
                          rememberMeParameter: false,
                          username: res.data.data[2],
                        });
                        this.getUserLoginDetails().then(() => {
                          this.updateUserLanguage();
                          this.$router.push('home');
                        });
                      } else { // error case
                        this.$router.push('/');
                      }
                    }
                    this.waitForResponse = false;
                  });
                } else {
                  window.location.href = redirectionUrl; // redirect to partner
                }
              });
            } else {
              if (resp === 'PIN_EXPIRED') {
                this.message = 'visitor_sign_up_2_pin_expired';
              } else if (resp === 'WRONG_PIN') {
                this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
              } else if (resp === 'BLOCKED_USER') {
                this.message = 'visitor_forgot_password_warning_msd_max_attempts';
              } else if (resp === 'SERVER_ERROR') {
                this.message = 'home_profile_profile_edit_server_unvailable';
              } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
                this.message = 'visitor_sign_up_warning_third_party_error';
              } else if (resp === 'TEST_MSISDN_ACTION_PERFOMED') {
                this.message = 'registration_process_with_test_msisdn_perfomed';
              }
              this.hasErrors = true;
              this.waitForResponse = false;
            }
          });
        }
      };
      default: return (asyncPinVerification) => { this.defaultVerifyAction(asyncPinVerification, hasServerTrack); };
      }
    },
    getNextForgotPasswordStep() {
      switch (this.simpleRegistration) {
      case this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName: return () => { this.$router.push('login'); };
      case this.availableFlows.SIMPLE_WITHOUT_WEB_REGISTRATION.propertyName: return () => { this.$router.push('login'); };
      default: return () => { this.$router.push('forgotPassword2'); };
      }
    },
    // ------- helpers -------------------
    defaultVerifyAction(asyncPinVerification, hasServerTrack) {
      this.$axios.get(`api/verifyPin?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}&publisherId=${this.getPublisherId}`).then((response) => {
        const resp = response.data.responseEnum;
        this.waitForResponse = false;
        if (resp === 'OPERATION_SUCCESS') {
          if (asyncPinVerification) this.asyncLoadingAction();
          else {
            const subscribedViaWeb = response.data.data.subscribedViaWeb;
            if (subscribedViaWeb && !hasServerTrack) {
              if (this.multiOperatorInfo.multiOperatorEnabled) {
                this.sendCompleteRegistrationEvent(this.multiOperatorInfo.operatorPicked.includes('DU') ? 'CompleteRegistrationDU' : '');
              } else {
                this.sendCompleteRegistrationEvent();
              }
            }
            this.$router.push('register3');
          }
        } else {
          if (resp === 'PIN_EXPIRED') {
            this.message = 'visitor_sign_up_2_pin_expired';
          } else if (resp === 'WRONG_PIN') {
            this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
          } else if (resp === 'BLOCKED_USER') {
            this.message = 'visitor_forgot_password_warning_msd_max_attempts';
          } else if (resp === 'SERVER_ERROR') {
            this.message = 'home_profile_profile_edit_server_unvailable';
          } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
            this.message = 'visitor_sign_up_warning_third_party_error';
          } else if (resp === 'TEST_MSISDN_ACTION_PERFOMED') {
            this.message = 'registration_process_with_test_msisdn_perfomed';
          }
          this.hasErrors = true;
        }
      });
    },
    asyncLoadingAction() {
      this.showLoadingModal = true;
      this.$axios.get(`api/getStatus?msisdn=${encodeURIComponent(this.registrationInfoMsisdn)}&lang=${this.getLocale}&pin=${this.user.pin}&correlationId=${this.getCorrelationId}`).then((res) => {
        this.showLoadingModal = false;
        if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
          const hasSub = res.data.data.isSub;
          if (hasSub === 'true') {
            this.sendCompleteRegistrationEvent();
          }
          const type = res.data.data.type;
          if (type === this.asyncTypes.AUTO) {
            this.storeLoginInfo({
              token: res.data.data.user_auth_token,
              rememberMeParameter: false,
              username: res.data.data.username,
            });
            this.getUserLoginDetails().then(() => {
              this.updateUserLanguage();
              this.$router.push('home');
            });
          } else {
            this.$router.push('register3');
          }
        } else { // error case
          this.$router.push('/');
        }
      });
    },
    sendCompleteRegistrationEvent(event) {
      this.$gtm.trackEvent({
        event: event || 'CompleteRegistration',
        category: 'MSISDN Registration',
        action: 'Register 2 registration',
        label: 'Register 2',
      });
    },
    hasRegSteps() {
      return this.simpleRegistration !== this.availableFlows.SIMPLE_BOTH_WEB_REGISTRATION_AND_LOGIN.propertyName;
    },
    show2stepsOnlyOrNoneInForgot() {
      return this.simpleRegistration === this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName || this.checkIfIntegrationRequires2StepOnly();
    },
    hasSimplify() {
      return this.simpleRegistration === this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName
        || this.simpleRegistration === this.availableFlows.SIMPLE_WITHOUT_WEB_REGISTRATION.propertyName;
    },
    hasWebRegister() {
      return this.simpleRegistration === this.availableFlows.SIMPLE_WITH_WEB_REGISTRATION.propertyName
        || this.simpleRegistration === this.availableFlows.SIMPLE_BOTH_WEB_REGISTRATION_AND_LOGIN.propertyName
        || this.simpleRegistration === this.availableFlows.DEFAULT.propertyName;
    },
    isString(value) {
      return typeof value === 'string' || value instanceof String;
    },
    showVerifyPinErrorMessage(resp) {
      if (resp === 'PIN_EXPIRED') {
        this.message = 'visitor_sign_up_2_pin_expired';
      } else if (resp === 'WRONG_PIN') {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
      } else if (resp === 'BLOCKED_USER') {
        this.message = 'visitor_forgot_password_warning_msd_max_attempts';
      } else if (resp === 'SERVER_ERROR') {
        this.message = 'home_profile_profile_edit_server_unvailable';
      } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
        this.message = 'visitor_sign_up_warning_third_party_error';
      } else if (resp === 'TEST_MSISDN_ACTION_PERFOMED') {
        this.message = 'registration_process_with_test_msisdn_perfomed';
      }
      this.hasErrors = true;
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
      'simpleRegistration',
      'availableFlows',
      'fbReferral',
    ]),
    ...mapState('game', [
      'registrationPoints',
    ]),
    ...mapGetters('profile', [
      'getUserAuthorized',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
      'getCorrelationId',
      'getInviteReferral',
    ]),
  },
};



// WEBPACK FOOTER //
// ./src/common/mixins/flow.js